var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.0794C26 5.85586 20.1797 0 13 0C5.82029 0 0 5.85586 0 13.0794C0 19.6078 4.75391 25.0188 10.9687 26V16.8602H7.66796V13.0794H10.9687V10.1979C10.9687 6.91984 12.9095 5.10916 15.879 5.10916C17.3013 5.10916 18.789 5.36461 18.789 5.36461V8.58339H17.1498C15.5349 8.58339 15.0312 9.5916 15.0312 10.6259V13.0794H18.6367L18.0603 16.8602H15.0312V26C21.2461 25.0188 26 19.6078 26 13.0794Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/faceBook.2a9eeb5adb267a3e58f1d677c384add9.svg";
export { ForwardRef as ReactComponent };